import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { getImageBaseUrl } from "../services/s3-utils";
import SvgPen2 from "../icons/SvgPen2";
import SvgPen from "../icons/SvgPen";
import cohort_ from "../assets/cohort_active.svg";
import cohort from "../assets/cohort.svg";

function DashboardMenu(props) {
  const navigate = useNavigate();
  const location = useLocation();
  const [openSideMobile, setOpenSideMobile] = useState(false);

  const leftLinks = [
    {
      text: "Dashboard",
      icon: <img src={`${getImageBaseUrl}/assets/team.svg`} alt="" />,
      icon2: <img src={`${getImageBaseUrl}/assets/team_.svg`} alt="" />,
      link: "/dashboard",
    },
    {
      text: "Cohorts",
      icon: <img src={cohort_} alt="" />,
      icon2: <img src={cohort} alt="" />,
      // link: "/cohort",
      // link2: "/cohort/viewcohorts",
      link: "/cohort",
      link2: "/cohort/create-cohort",
    },
    {
      text: "QNotes",
      icon: <SvgPen currentColor={"#5f5ffa"} />,
      icon2: <SvgPen2 currentColor={"#7575a9"} />,
      link: "/qnotes",
    },
    {
      text: "Calendar",
      link: "/calendar",
      icon: <img src={`${getImageBaseUrl}/assets/calendar1.svg`} alt="" />,
      icon2: <img src={`${getImageBaseUrl}/assets/calendar_.svg`} alt="" />,
    },

    {
      text: "Settings",
      link: "/settings/profile",
      link2: "/settings",
      icon: <img src={`${getImageBaseUrl}/assets/cog_.svg`} alt="" />,
      icon2: <img src={`${getImageBaseUrl}/assets/cog.svg`} alt="" />,
    },
  ];

  return (
    <>
      <div
        onClick={() => setOpenSideMobile(false)}
        className={`w-full h-screen absolute top-0 left-0 opacity-0 z-[70] backdrop-blur-md bg-[#48474799] ${
          openSideMobile ? "opacity-100 block z-[100]" : "hidden"
        }`}
      ></div>
      <div className="pl-5 lg:hidden top-[32px] absolute z-[90]">
        <span className="lg:hidden flex items-center">
          <img
            src={`${getImageBaseUrl}/assets/menu.svg`}
            alt=""
            className="w-6 h-6"
            onClick={() => setOpenSideMobile(!openSideMobile)}
          />
        </span>
      </div>

      <div
        className={`w-[230px] h-screen border-r-1 border-grey-2 pr-10 pt-[26px] pb-[21px] lg:sticky top-0 fixed bg-white transition-all duration-500 ease-in-out ${
          openSideMobile ? "opacity-100 left-0 z-[110]" : "-left-[230px]"
        }`}
      >
        <div className="px-10 mb-12">
          <Link to="/">
            <span className="flex items-center text-xl text-main">
              <img src={`${getImageBaseUrl}/assets/logo.svg`} alt="" />
            </span>
          </Link>
        </div>
        <div className="nav-links">
          {leftLinks.map((link, i) => {
            const isActive =
              location.pathname === link.link ||
              location.pathname === link.link2 ||
              location.pathname.includes(link.link);
            return (
              <div
                key={i}
                className={`flex items-center pointer mb-4 pl-10 py-[10px] gap-3 text-base leading-[29px] ${
                  isActive && "active-link-settings pri"
                }`}
                onClick={() => {
                  if (window.innerWidth < 1024) {
                    setOpenSideMobile(!openSideMobile);
                  }
                  navigate(link.link);
                }}
              >
                {!isActive ? <>{link.icon2}</> : <>{link.icon}</>}
                {link.text}
              </div>
            );
          })}
        </div>
      </div>
    </>
  );
}

export default DashboardMenu;
